import React, { useEffect, useState } from "react";
import { fetchBlogs } from "../contentfulClient";

function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getBlogs() {
      try {
        const data = await fetchBlogs();
        setBlogs(data);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    }

    getBlogs();
  }, []);

  return (
    <div className="blogs-page">
      {/* Banner Section */}
      <section className="about-banner position-relative overflow-hidden">
        <div className="container text-center position-relative z-index-1">
          <h1 className="display-5 fw-bold mb-3">Our Blogs</h1>
          <p className="lead">
            Explore our latest insights, tips, and stories on facility
            management and services.
          </p>
        </div>
      </section>

      {/* Blogs Content */}
      <section className="blogs-content py-5 bg-light">
        <div className="container py-5">
          {loading ? (
            <p className="text-center">Loading blogs...</p>
          ) : blogs.length === 0 ? (
            <p className="text-center">No blogs available.</p>
          ) : (
            <div className="row g-4">
              {blogs.map((blog) => (
                <div key={blog.id} className="col-md-4">
                  <div className="card h-100 shadow-sm">
                    <img
                      src={blog.image || "https://via.placeholder.com/300x200"}
                      alt={blog.name}
                      className="card-img-top"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title">{blog.name}</h5>
                      <p className="card-text flex-grow-1">
                        {blog.description}
                      </p>
                      <a
                        href={`/blogs/${blog.id}`}
                        className="btn btn-primary mt-3"
                      >
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Blogs;
